import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TravelSheetService } from '../../services/travel-sheet.service';

@Component({
  selector: 'app-my-unapproved-travel-sheets',
  templateUrl: './my-unapproved-travel-sheets.component.html',
  styleUrls: ['./my-unapproved-travel-sheets.component.css']
})
export class MyUnapprovedTravelSheetsComponent implements OnInit {

  travelSheetList;
  constructor(private travelSheetService: TravelSheetService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getUnApprovedSheet();
  }

  getUnApprovedSheet() {
    this.travelSheetService.getUnApprovedSheetDetails().subscribe((resp: any) => {
      this.travelSheetList = resp;
      console.log('unapproved travel sheet list', this.travelSheetList);
    });
  }

  resendReason;
  openModal(modalContent, travelSheet) {
    this.modalService.open(modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'md', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
    console.log('travelsheet details', travelSheet);
    this.resendReason = travelSheet.reason;
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
